module.exports = __webpack_public_path__ + "img/hero-dropdown-search-kia.a271c0ca.png";